import Layout from '../components/[tableHash]/newLayout/Layout';

export const hubLayout = (page, pageProps) => <Layout {...pageProps}>{page}</Layout>;
